import type { IconSvgObject } from './types';

const MinusPlusCircle02Icon: IconSvgObject = [
  ["path", { d: "M16 8L8 16M15 17V15M15 15V13M15 15H13M15 15H17M8 9.5H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MinusPlusCircle02Icon;
